import EmblaCarousel from "embla-carousel";
import AutoHeight from 'embla-carousel-auto-height';
import Fade from 'embla-carousel-fade';

function init() {


  const first_level_links = document.querySelectorAll(".main-menu-container .menu-item-level-1");
  const second_level_links = document.querySelectorAll(".main-menu-container .menu-item-level-2 > a");


  function hasSubmenu(link) {
    return link.querySelector("ul");
  }
  function supportsMouse() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }



  function closeSub(link){
    if (link) {
      link.classList.remove("is-open");
      link.closest("header").classList.remove("is-open");
      opened = null;
    }
  }

  let opened = null
  let closeTimeout = null

  first_level_links.forEach((link) => {
    link.addEventListener("mouseenter", (event) => {
      closeSub(opened)
      clearInterval(closeTimeout);
      if (hasSubmenu(link) && supportsMouse()) {
        link.classList.add("is-open");
        link.closest("header").classList.add("is-open");
        opened = link;
      }
      
      
      
    });
    link.addEventListener("mouseleave", (event) => {
      if (hasSubmenu(link) && supportsMouse()) {
        closeTimeout = setTimeout(() => {
          closeSub(link)
        }, 600);
      }
    });
    link.querySelector("a").addEventListener("click", (event) => {
      if (hasSubmenu(link) && supportsMouse()) {
        event.preventDefault();
        link.classList.add("is-open");
        link.closest("header").classList.add("is-open");
      }

      const clickedLink = event.currentTarget;

      if (clickedLink.nextElementSibling && !supportsMouse()) {
        event.preventDefault();
        clickedLink.nextElementSibling.classList.toggle("is-open");

        //chiudo gli altri menu di primo livello aperti
        first_level_links.forEach((li) => {
          const a = li.querySelector("a");
          const sub = a.nextElementSibling;
          if (sub && sub !== clickedLink.nextElementSibling) {
            sub.classList.remove("is-open");
          }
        });

        // Chiudi gli altri menu di secondo livello aperti        
        second_level_links.forEach((otherLink) => {
          if (otherLink !== clickedLink && otherLink.nextElementSibling) {
            otherLink.nextElementSibling.classList.remove("is-open");
          }
        });
      }
    });
  })

  second_level_links.forEach((link) => {
    link.addEventListener("click", (event) => {
      if (link.nextElementSibling) {
        event.preventDefault();
        link.nextElementSibling.classList.toggle("is-open");


        second_level_links.forEach((otherLink) => {
          if (otherLink !== link && otherLink.nextElementSibling) {
            otherLink.nextElementSibling.classList.remove("is-open");
          }
        });

      };
    });
  })

  //MOBILE
  const mobileMenuToggle = document.querySelector(".mobile-menu-toogle");
  const mobileMenuClose = document.querySelector(".mobile-menu-close");

  const mainMenu = document.getElementById("main-menu");

  if (mobileMenuToggle && mainMenu) {
    mobileMenuToggle.addEventListener("click", (event) => {
      event.preventDefault();
      document.documentElement.classList.add('menu-mobile-open');
      mainMenu.classList.add("is-open");
    });
  }

  if (mobileMenuClose && mainMenu) {
    mobileMenuClose.addEventListener("click", (event) => {
      event.preventDefault();
      document.documentElement.classList.remove('menu-mobile-open');
      mainMenu.classList.remove("is-open");

      first_level_links.forEach((li) => {
        const a = li.querySelector("a");
        const sub = a.nextElementSibling;
        if (sub) {
          sub.classList.remove("is-open");
        }
      });

      second_level_links.forEach((otherLink) => {
        if (otherLink.nextElementSibling) {
          otherLink.nextElementSibling.classList.remove("is-open");
        }
      });

    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
